// WebSocket error handler to suppress connection errors
// These errors are normal during page transitions and don't affect functionality

export const setupWebSocketErrorHandler = () => {
  // Store original console.error
  const originalConsoleError = console.error

  // Override console.error to filter out WebSocket connection errors
  console.error = (...args: any[]) => {
    const message = args.join(' ')
    
    // Filter out WebSocket connection errors that are normal during page transitions
    if (
      message.includes('WebSocket is closed before the connection is established') ||
      message.includes('WebSocket connection failed') ||
      message.includes('WebSocket connection to') && message.includes('failed')
    ) {
      // Don't log these errors as they're expected during page transitions
      return
    }
    
    // Log all other errors normally
    originalConsoleError.apply(console, args)
  }

  // Return cleanup function
  return () => {
    console.error = originalConsoleError
  }
}

// Call this in your main.tsx or App.tsx
export const initWebSocketErrorHandler = () => {
  if (typeof window !== 'undefined') {
    setupWebSocketErrorHandler()
  }
}







